<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="notification-list">
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="sm"
      spinner-variant="primary"
    >
      <b-card>
        <h4 class="heading">{{ $t("NotificationSettingsforAdmin") }}</h4>
        <div class="export-table description noti1">
          <b-table
            :current-page="currentPage"
            :per-page="perPage"
            :items="notificationsAdmin"
            :fields="fields"
            :busy="isBusy"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            responsive
            show-empty
            :filter="filter"
            :filter-included-fields="filterOn"
            :empty-text="$t('EmptyData')"
            :empty-filtered-text="$t('EmptyFilter')"
          >
            <template #head()="data">
              <span>{{ $t(data.label) }}</span>
            </template>
            <template #cell(slug)="data">
              <div class="mt-2">
                {{ $t(data.item.slug) }}
              </div>
            </template>
            <template #cell(action)="data">
              <form
                name="staff_form"
                v-if="data.item.slug == 'sender_name'"
                method="post"
                v-on:submit.prevent="$event.preventDefault()"
              >
                <div class="w-full">
                  <div
                    class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 flex"
                  >
                    <b-form-input
                      size="lg"
                      :placeholder="$t(data.item.slug)"
                      v-validate="{ required: true }"
                      :data-vv-as="$t('sender_name')"
                      name="sms_sender_id"
                      v-model="data.item.sender_name"
                      class="w-full"
                    ></b-form-input>

                    <div class="vx-col ml-2 mt-2 float-right">
                      <b-button
                        size="md"
                        type="filled"
                        variant="primary"
                        @click.prevent="
                          submitForm(data.item.sender_name, data.item.slug)
                        "
                        class="border-primary"
                        >{{ $t("Submit") }}</b-button
                      >
                    </div>
                  </div>
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('sms_sender_id')"
                    >{{ errors.first("sms_sender_id") }}</span
                  >
                </div>
              </form>
              <div v-else class="walk-card">
                <b-form-checkbox
                  class="col w-1/2"
                  v-b-tooltip.hover
                  :title="
                    data.item.is_enabled == 0 ? $t('Disabled') : $t('Enabled')
                  "
                  v-model="data.item.is_enabled"
                  size="lg"
                  name="cell_width"
                  switch
                  @change="
                    changeVisiblity(data.item.is_enabled, data.item.slug)
                  "
                >
                </b-form-checkbox>
              </div>
            </template>
          </b-table>
        </div>
      </b-card>
      <b-card class="mt-5">
        <h4 class="heading">{{ $t("NotificationSettingsforUser") }}</h4>
        <div class="export-table description noti1">
          <b-table
            :current-page="currentPage"
            :per-page="perPage"
            :items="notificationsUserFirstReminder"
            :fields="fields"
            :busy="isBusy"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            responsive
            show-empty
            :filter="filter"
            :filter-included-fields="filterOn"
            :empty-text="$t('EmptyData')"
            :empty-filtered-text="$t('EmptyFilter')"
            thead-class="d-none"
          >
            <template #cell(slug)="data">
              <div class="mt-2">
                {{ $t(capitalizeFirstLetter(data.item.title)) }}
              </div>
            </template>
            <template #cell(action)="data">
              <div>
                <div
                  class="vx-row w-full"
                  v-if="data.item.slug == 'first_reminder_period'"
                >
                  <b-input
                    name="first_time"
                    v-validate="{ required: true, numeric: true }"
                    v-model="firstTime"
                    size="lg"
                    placeholder="48"
                    class="vx-col w-1/6 ml-4 time-input"
                    :data-vv-as="$t('TimePeriod')"
                    onkeypress="return /[0-9]/i.test(event.key)"
                    @input="
                      checkVisiblity(
                        data.item.is_enabled,
                        data.item.slug,
                        firstTime,
                        firstPer
                      )
                    "
                  ></b-input>

                  <v-select
                    name="first_period"
                    v-validate="{ required: true }"
                    v-model="firstPer"
                    class="vx-col w-1/3"
                    :options="options"
                    :reduce="(label) => label.value"
                    label="label"
                    :data-vv-as="$t('Period')"
                    @input="
                      checkVisiblity(
                        data.item.is_enabled,
                        data.item.slug,
                        firstTime,
                        firstPer
                      )
                    "
                  >
                    <template v-slot:option="option">
                      <span :class="option.icon">{{ option.label }} </span>
                      <feather-icon
                        v-if="firstPer == option.value"
                        icon="CheckIcon"
                        class="float-right"
                        svgClasses="w-5 h-5"
                      />
                    </template>
                  </v-select>

                  <span
                    class="text-danger text-sm ml-4 w-full mt-2"
                    v-show="errors.has('first_time')"
                    >{{ errors.first("first_time") }}</span
                  >

                  <span
                    class="text-danger text-sm ml-4 mt-2"
                    v-show="errors.has('first_period')"
                    >{{ errors.first("first_period") }}</span
                  >
                </div>
                <div v-else class="walk-card">
                  <b-form-checkbox
                    class="col w-1/2"
                    v-model="data.item.is_enabled"
                    size="lg"
                    name="cell_width"
                    switch
                    @change="
                      changeVisiblity(data.item.is_enabled, data.item.slug)
                    "
                  >
                  </b-form-checkbox>
                </div>
              </div>
            </template>
          </b-table>
          <b-table
            :items="notificationsUserSecondReminder"
            :fields="fields"
            responsive
            class="noti1"
            thead-class="d-none"
          >
            <template #cell(slug)="data">
              <div class="mt-2">
                {{ $t(capitalizeFirstLetter(data.item.title)) }}
              </div>
            </template>
            <template #cell(action)="data">
              <div>
                <div
                  class="vx-row w-full"
                  v-if="data.item.slug == 'second_reminder_period'"
                >
                  <b-form-input
                    v-validate="{ required: true, numeric: true }"
                    v-model="secondTime"
                    size="lg"
                    placeholder="24"
                    name="second_time"
                    class="vx-col w-1/6 time-input ml-4"
                    :data-vv-as="$t('TimePeriod')"
                    onkeypress="return /[0-9]/i.test(event.key)"
                    @input="
                      checkVisiblity(
                        data.item.is_enabled,
                        data.item.slug,
                        secondTime,
                        secondPer
                      )
                    "
                  ></b-form-input>

                  <v-select
                    name="second_period"
                    v-validate="{ required: true }"
                    v-model="secondPer"
                    class="vx-col w-1/3"
                    :options="options"
                    :reduce="(label) => label.value"
                    :data-vv-as="$t('Period')"
                    @input="
                      checkVisiblity(
                        data.item.is_enabled,
                        data.item.slug,
                        secondTime,
                        secondPer
                      )
                    "
                    label="label"
                  >
                    <template v-slot:option="option">
                      <span :class="option.icon">{{ option.label }} </span>
                      <feather-icon
                        v-if="secondPer == option.value"
                        icon="CheckIcon"
                        class="float-right"
                        svgClasses="w-5 h-5"
                      />
                    </template>
                  </v-select>

                  <span
                    class="text-danger text-sm ml-4 w-full mt-2"
                    v-show="errors.has('second_time')"
                    >{{ errors.first("second_time") }}</span
                  >

                  <span
                    class="text-danger text-sm ml-4 mt-2"
                    v-show="errors.has('second_period')"
                    >{{ errors.first("second_period") }}</span
                  >
                </div>
                <div v-else class="walk-card">
                  <b-form-checkbox
                    class="col w-1/2"
                    v-model="data.item.is_enabled"
                    size="lg"
                    name="cell_width"
                    switch
                    @change="
                      changeVisiblity(data.item.is_enabled, data.item.slug)
                    "
                  >
                  </b-form-checkbox>
                </div>
              </div>
            </template>
          </b-table>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import $ from "jquery";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      notificationsUser: [],
      notificationsAdmin: [],
      notificationsUserFirstReminder: [],
      notificationsUserSecondReminder: [],
      options: [
        { label: this.$t("Hours"), value: "hours" },
        { label: this.$t("Minutes"), value: "minutes" },
        { label: this.$t("Days"), value: "days" },
      ],
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",

      perPage: 11,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      fields: [
        {
          key: "slug",
          label: "Title",
          sortable: false,
          sortDirection: "desc",
          class: "w-1/2",
        },
        { key: "action", label: "Action", sortable: false, class: "w-1/2" },
      ],
      //added on 19-11-2021
      first_reminder: false,
      second_reminder: false,
      firstTime: "48",
      secondTime: "24",
      firstTime1: "",
      secondTime1: "",
      firstPer: "hours",
      secondPer: "hours",
      //end
    };
  },
  computed: {
    rows() {
      if (this.notifications) return this.notifications.length;
      else 0;
    },
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        (this.options = [
          { label: this.$t("Hours"), value: "hours" },
          { label: this.$t("Minutes"), value: "minutes" },
          { label: this.$t("Days"), value: "days" },
        ]),
          this.loadLocale(value);
      },
    },
  },
  created() {

    this.getNotification();
    this.loadLocale(this.$i18n.locale);
  },

  methods: {
    /**
     *
     * Capitlise first latter
     **/
    capitalizeFirstLetter(string) {
      let str = string.charAt(0).toUpperCase() + string.slice(1);
      return str.replace(/ /g, "");
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     *
     * getDepartments   method  for list all departments data
     **/
    getNotification() {
      this.show = true;

      this.$store
        .dispatch("GetNotification", this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id :  this.$store.getters.currentUser.id)
        .then((res) => {
          var notifications = res.data.data;

          this.notificationsUser = notifications;

           notifications.map((element, index) => {
            if (notifications[index].slug == "smtp_preference") {
              notifications.splice(index, 1);
            }
           });

          notifications.map((element, index) => {
          
            if (
              notifications[index].slug == "staff_sms_reminder" ||
              notifications[index].slug == "sender_name" || notifications[index].slug == "staff_sms_call"
            ) {
              console.log('element', element);
              notifications[index].is_enabled = element.is_enabled == true || element.is_enabled == 1 ? true : false;
              this.notificationsAdmin.push(notifications[index]);
              console.log(this.notificationsAdmin);
            } else if (notifications[index].slug == "first_reminder") {
              notifications[index].is_enabled =
                element.is_enabled == true ? true : false;
              this.first_reminder = notifications[index].is_enabled;
              this.notificationsUserFirstReminder.push(notifications[index]);
            } else if (notifications[index].slug == "second_reminder") {
              notifications[index].is_enabled =
                element.is_enabled == true ? true : false;
              this.second_reminder = notifications[index].is_enabled;
              this.notificationsUserSecondReminder.push(notifications[index]);
            }
          });
          this.getRemindarFields();
          this.show = false;
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getNotification() | Error :",
            error
          );
          this.show = false;
          // Error response
          if (error) {
            this.error =
              this.$t(error.replace(/[\s\/]/g, "")) !==
              error.replace(/[\s\/]/g, "")
                ? this.$t(error.replace(/[\s\/]/g, ""))
                : error;
            this.$toasted.show(this.error, {
              className: "top-alert",
              position: "top-center",
              type: "error",
              duration: 2000,
            });
          }
          return false;
        });
    },
    /**
     * check visiblity
     */
    checkVisiblity(value, slug, time, per) {
      let first = "first_reminder_period";
      let second = "second_reminder_period";
      let period = `${time}-${per}`;
      if (slug == first && !time) period = "48-hours";
      else if (slug == second && !time) period = "24-hours";
      this.changeVisiblity(value, slug, period);
    },

    getRemindarFields() {
      //added on 19-11-2021
      let email = this.notificationsUserFirstReminder.some(
        (element) => element.slug == "first_reminder_email"
      );
      let sms = this.notificationsUserFirstReminder.some(
        (element) => element.slug == "first_reminder_sms"
      );
      let per = this.notificationsUserFirstReminder.some(
        (element) => element.slug == "first_reminder_period"
      );
      let email1 = this.notificationsUserSecondReminder.some(
        (element) => element.slug == "second_reminder_email"
      );
      let sms1 = this.notificationsUserSecondReminder.some(
        (element) => element.slug == "second_reminder_sms"
      );
      let per1 = this.notificationsUserSecondReminder.some(
        (element) => element.slug == "second_reminder_period"
      );
      // end

      this.notificationsUser.map((element, index) => {
        if (this.first_reminder) {
          if (
            element.slug == "first_reminder_sms" ||
            element.slug == "first_reminder_email" ||
            element.slug == "first_reminder_period"
          ) {
            element.is_enabled = element.is_enabled == true ? true : false;
            //added on 19-11-2021
            if (element.slug == "first_reminder_period")
              this.firstTime = element.period;
            if (!email || !sms || !per)
              this.notificationsUserFirstReminder.push(element);
            // end
          }
        } else {
          this.notificationsUserFirstReminder.splice(1, 3);
        }
        if (this.second_reminder) {
          if (
            element.slug == "second_reminder_sms" ||
            element.slug == "second_reminder_email" ||
            element.slug == "second_reminder_period"
          ) {
            element.is_enabled = element.is_enabled == true ? true : false;
            //added on 19-11-2021
            if (!email1 || !sms1 || !per1)
              this.notificationsUserSecondReminder.push(element);
            if (element.slug == "second_reminder_period")
              this.secondTime = element.period;
            //end
          }
        } else {
          this.notificationsUserSecondReminder.splice(1, 3);
        }
      });

      //added on 19-11-2021
      if (this.firstTime != null) {
        let temp = this.splitChar(this.firstTime);
        this.firstTime = temp[0];
        this.firstPer = temp[1];
      }

      if (this.secondTime != null) {
        let temp1 = this.splitChar(this.secondTime);
        this.secondTime = temp1[0];
        this.secondPer = temp1[1];
      }
      let tempFirst=this.firstTime||"48";
      this.firstTime=tempFirst;
       let tempSecond=this.secondTime||"24";
      this.secondTime=tempSecond;
      //end
    },

    splitChar(str) {
      return str.split(/[ ,.-]+/);
    },

    /**
     * open popup
     */
    changeVisiblity(value, slug, period = null) {
      var data = {
        slug: slug,
        is_enabled: value,
        company_id: this.$store.getters.roles == "assistant" ? this.$store.getters.currentUser.company_id : this.$store.getters.currentUser.id,
      };

      if (period != null) data.period = period;

      this.$store
        .dispatch("UpdateNotificationStatus", data)
        .then((res) => {
          console.log("data", res);
          if (slug == "first_reminder" || slug == "second_reminder") {
            if (slug == "first_reminder") {
              this.first_reminder = value;
            } else {
              this.second_reminder = value;
            }
            this.getRemindarFields();
          }
          this.show = false;

          this.$toasted.show(this.$t("NotificationSettingUpdate"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : Form.vue | Function : updateRooms() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    submitForm(sender_name, index) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.changeVisiblity(sender_name, index);
        }
      });
    },
  },
};
</script>

<style lang="stylus" scope>
.notification-list {
  .heading {
    margin-bottom: 20px;
  }

  .add {
    position: absolute;
    margin-top: 10px;
  }

  .action {
    margin-left: 20px;
    display: inline;
  }

  .con-vs-tooltip {
    display: inline;
  }

  .v-select {
    min-width: 180px;
  }

  .vs-con-table .vs-con-tbody {
    width: 100%;
    overflow: visible;
  }

  .description td, .description th {
    border: none !important;
  }

  .cu-vx-row {
    margin: 0 !important;
  }

  .vx-row {
    margin-top: 0px !important;
  }

  .time-input {
    padding: 21px !important;
  }

  .noti1 .table-responsive {
    overflow-x: unset !important;
  }
}
</style>